<template>
    <section>
        <div v-if="((Object.values(dados.settings).length) && (selectedPlano.recorrencias.length))" class="p-0">
            <div class="pricing-table">
                <vue-slick-carousel v-bind="dados.settings">
                    <template #prevArrow="arrowOption">
                        <div class="custom-arrow" :style="($route.name=='confirmar-plano')?'left:-1.5rem;':sizeLeft">
                            {{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}
                        </div>
                    </template>
                    <template #nextArrow="arrowOption">
                        <div class="custom-arrow" :style="($route.name=='confirmar-plano')?'right:-0.3rem;':sizeRight">
                            {{ arrowOption.currentSlide }}/{{ arrowOption.slideCount }}
                        </div>
                    </template>
                    <template v-for="(recorrencia, i) in selectedPlano.recorrencias">
                        <div class="pricing-item pointer col-11 p-0 mx-0" @mousedown="setRecorrencia(recorrencia)"
                            :key="i">
                            <transition name="animeSelected" mode="in-out">
                                <div v-if="dados.selected.fk_validade_id == recorrencia.id" class='selected'>Selecionado
                                </div>
                            </transition>
                            <div class="pricing-title w-100 pt-3 pb-5"
                                :style="`background: rgb(${40-(i*5)},${160-(i*23)},${200-(i*25)}`">
                                {{recorrencia.nome}}
                            </div>
                            <div class="pricing-value px-2 px-xl-5 d-block">
                                <p v-if="recorrencia.valorTotal != recorrencia.valorFinal" class="text-gray smallText">
                                    {{formatMoney(recorrencia.valorTotal)}}
                                </p>
                                <!-- <p v-if="recorrencia.valorTotal == recorrencia.valorFinal" class="pt-5 d-block"></p> -->
                                <span class="d-flex justify-content-center pt-5 pb-3">
                                    <span class="moneytext d-flex mr-2">R$ </span>
                                    {{ formatMoney(recorrencia.valorFinal).substr(3) }}
                                </span>
                                <!-- <p v-if="recorrencia.valorTotal == recorrencia.valorFinal" class="pb-5 mb-4 d-block"></p> -->
                                <p v-if="recorrencia.valorTotal != recorrencia.valorFinal"
                                    class="undertext d-block mb-5">
                                    <span class="keywords">{{recorrencia.desconto}} % </span> de desconto
                                </p>
                            </div>
                            <ul class="pricing-features my-3 mx-0">
                                <li><span class="keywords">{{selectedPlano.documentos}}</span>
                                    <span> Upload Arquivo </span>
                                </li>
                                <li><span class="keywords">{{selectedPlano.usuarios}}</span>
                                    <span> Usuários </span>
                                </li>
                                <li>
                                    <span>Cobrança a cada </span>
                                    <span class="keywords">{{recorrencia.vencimento}}</span>
                                    <span> dias</span>
                                </li>
                                <li>
                                    <span>Cancele </span>
                                    <span class="keywords">a qualquer hora</span>
                                </li>
                            </ul>
                            <div class="btn btn-primary mb-3">{{$t('words.select')}}</div>
                        </div>
                    </template>
                </vue-slick-carousel>
            </div>
        </div>
        <template v-else>
            <div class="container">
                <div class="row my-5">
                    <div class="col offset-5">
                        <i class="fa fa-2x fa-circle-o-notch fa-spin"></i>
                    </div>
                </div>
            </div>
        </template>
    </section>
</template>

<script>
    import 'vue-slick-carousel/dist/vue-slick-carousel.css'
    import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    import VueSlickCarousel from 'vue-slick-carousel';
    export default {
        props: ['dados', 'selectedPlano'],
        components: {
            VueSlickCarousel,
        },
        beforeMount() {},
        computed: {
            adicionais() {
                return this.$store.state.plano.adicionais;
            },
            sizeLeft() {
                return (window.innerWidth > 992) ? 'left:-2.5rem;' : 'left:0.5rem;';
            },
            sizeRight() {
                return (window.innerWidth > 992) ? 'right:-1.5rem;' : 'right:1.5rem;';
            }
        },
        methods: {
            setRecorrencia(payload) {
                this.dados.selected.fk_validade_id = payload.id;
                this.dados.selected.planoValor = payload.valorFinal;
                this.$store.commit('SET_ADICIONAIS', payload.adicionais);
                this.$emit('selectRecorrencia', payload);
                this.fixAditionalValues();
            },
            fixAditionalValues() {
                this.dados.selected.adicionais.map(item => {
                    item.valor = parseFloat(this.adicionais.find(x => x.id === item.id).valor);
                });
            },
            validate() {
                if (this.dados.selected.fk_validade_id) return true
                else {
                    toastr({
                        icon: 'error',
                        title: 'Selecione uma Assinatura',
                        timer: 5000
                    });
                    return false
                }
            },
        }
    }
</script>

<style scoped src="@/assets/sass/bootstrap4.css"></style>
<style scoped src="@/assets/sass/home.css"></style>
<style scoped lang="scss" src="./register.scss"></style>

<style scoped>
    .animeSelected-enter-active {
        animation-name: selected;
        animation-duration: 0.6s;
        animation-fill-mode: both;
    }

    @keyframes selected {
        from {
            transform: rotate(310deg) scale(1.5);
        }

        to {
            transform: rotate(310deg) scale(1);
        }
    }
</style>